// IndividualField.jsx
import React from 'react'
import classes from './IndividualField.module.css'

const IndividualField = ({
  label,
  name,
  value = '',
  onChange,
  editMode = false,
  type = 'text',
  required ,
  ...rest
}) => {
  return (
    <div className={classes.box}>
      <label className={classes.txt}>{label}{required && <span className='req'>*</span>}</label>
      <input
        name={name} // ← must have name for onChange to work
        type={type}
        className={classes.txtfield}
        value={value ?? ''} // safe empty string fallback
        onChange={onChange}
        readOnly={!editMode}
        // disabled={!editMode}         // ← optional: better visual cue (grayed out)
        // style={{
        //   backgroundColor: editMode ? 'white' : '#f5f5f5',
        //   cursor: editMode ? 'text' : 'not-allowed',
        // }}
        {...rest}
      />
    </div>
  )
}

export default IndividualField
